import { COLOUR, SEVERITY_COLOURS, SEVERITY_COLOURS_BRIGHT } from '../../constants';

export default (severity, { bright, defaultColour } = {}) => {
  return (bright ? SEVERITY_COLOURS_BRIGHT : SEVERITY_COLOURS)[severity] || defaultColour || (bright ? 'grey' : COLOUR.GREY);
};